// extracted by mini-css-extract-plugin
export default {"Checkbox":"CreateIssueFooter-module__Checkbox--l4pYZ"};